import Machines_A_0 from './Machines_A/Machines_A_0'
import Machines_A_1 from './Machines_A/Machines_A_1'
import Machines_A_2 from './Machines_A/Machines_A_2'
import Machines_A_3 from './Machines_A/Machines_A_3'
import Machines_A_4 from './Machines_A/Machines_A_4'
import Machines_A_5 from './Machines_A/Machines_A_5'
import Machines_A_6 from './Machines_A/Machines_A_6'
import Machines_A_7 from './Machines_A/Machines_A_7'
import Machines_A_8 from './Machines_A/Machines_A_8'
import Machines_A_9 from './Machines_A/Machines_A_9'
import Machines_A_10 from './Machines_A/Machines_A_10'
import Machines_A_11 from './Machines_A/Machines_A_11'

const Machines_A = [
  Machines_A_0,
  Machines_A_1,
  Machines_A_2,
  Machines_A_3,
  Machines_A_4,
  Machines_A_5,
  Machines_A_6,
  Machines_A_7,
  Machines_A_8,
  Machines_A_9,
  Machines_A_10,
  Machines_A_11
]

export default Machines_A



// WEBPACK FOOTER //
// ./src/components/Machines_A.js